import { render } from "./AmexIcon.vue?vue&type=template&id=1b4615ba"
import script from "./AmexIcon.vue?vue&type=script&lang=js"
export * from "./AmexIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__